import { getReplyWithProperties, ReplyWithProperties } from './getReplyWithProperties';
import getReplyWithSuggestions from '../services/getReplyWithSuggestions';
import { AttachmentSuggestions, ClientItem } from 'owa-mail-store';

export default async function fetchReplyWithSuggestions(
    referenceItem: ClientItem
): Promise<AttachmentSuggestions | null> {
    let replyWithSuggestions: AttachmentSuggestions = null;
    const properties: ReplyWithProperties = await getReplyWithProperties(referenceItem);

    if (properties) {
        replyWithSuggestions = await getReplyWithSuggestions(properties);
    }

    return replyWithSuggestions;
}
